import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
const oldApp = () => import('./components/App.vue');
const newApp = () => import('./components/re-design/App.vue');

export class CoreModule implements VueModule {
  readonly name = 'core'
  constructor(private router: VueRouter, private store: Store<any>,private service:any) {
  }
  install(Vue: typeof _Vue) {
    new Vue({
      router: this.router,
      store: this.store,
      provide:this.service,
      render: h => h(newApp)
    }).$mount('#app')
  }
}
